import script from "./employee.vue?vue&type=script&setup=true&lang=js"
export * from "./employee.vue?vue&type=script&setup=true&lang=js"

import "./employee.vue?vue&type=style&index=0&id=3cbf7e96&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cbf7e96"]])

export default __exports__